import React from 'react';

import { Button, type ButtonProps } from '@mui/material';

const deleteStates = {
  delete: 'Delete',
  deleting: 'Deleting...',
  failed: 'Failed to delete',
} as const;

export type DeleteButtonState = keyof typeof deleteStates;

interface Props {
  buttonText: DeleteButtonState;
  onClick: () => void;
  size?: ButtonProps['size'];
}

export const DeleteButton = ({ buttonText, onClick, size = 'medium' }: Props) => {
  return (
    <Button onClick={onClick} variant="text" size={size}>
      {deleteStates[buttonText]}
    </Button>
  );
};
